import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=272161d9&scoped=true&"
import script from "./OrderNew.vue?vue&type=script&lang=js&"
export * from "./OrderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272161d9",
  null
  
)

export default component.exports